import React from 'react';
import BreadcrumbRenderer from '@atlassian/jira-breadcrumbs/src/breadcrumb-renderer/index.tsx';

const QueuesBreadcrumbRendererNew = () => <BreadcrumbRenderer />;

export default QueuesBreadcrumbRendererNew;
